import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs, 'es');
import { RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { KycService } from '../../services/kyc.service';
import Swal from 'sweetalert2';
import { KycService as ModalKycSrv } from '../../services/modal-kyc/kyc.service';
import { DigitalWalletService } from '../../services/digital-wallet.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { SharedModule } from '../shared/shared.module';
import { NotificationBellComponent } from '../shared/notification-bell/notification-bell.component';

@Component({
  selector: 'app-menu-movil',
  templateUrl: './menu-movil.component.html',
  styleUrls: ['./menu-movil.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbCollapseModule, SharedModule, NotificationBellComponent]
})
export class MenuMovilComponent implements OnInit {
  isDrawerOpen: boolean = false;
  userAuth: any = null;
  loggedIn: boolean = false;
  adminFlag: boolean = false;
  kycFlag: boolean = false;
  menuOpened: boolean = false;
  balance: number = 0;
  balanceError: boolean = false;
  isLoadingBalance: boolean = false;
  digitalWalletCollapsed: boolean = false;
  eurosCollapsed: boolean = false;
  helpCollapsed: boolean = false; 
  profileCollapsed: boolean = false;
  myInvestmentsCollapsed: boolean = false;
  hideBlockchain: boolean = true;
  referralsCollapsed: boolean = false;  
  canCheckBalance: boolean = false;
  firstTime: boolean = false;
  lock: boolean = false;
  counter: number = 0;
  
  constructor(
    private authSrv: AuthService, 
    private kycSrv: KycService,
    private crf: ChangeDetectorRef,
    public router: Router,
    private modalKycSrv: ModalKycSrv,
    private digitalWalletSrv: DigitalWalletService,
    private afs: AngularFirestore,
    private ngZone: NgZone
  ) {}

  toggleDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
    this.crf.detectChanges();
  }

  private lastSectionToggleAt = 0;

  toggleSection(section: 'myInvestments' | 'digitalWallet' | 'help', event: Event) {
    event.stopPropagation();
    const now = Date.now();
    if (now - this.lastSectionToggleAt < 250) {
      return;
    }
    this.lastSectionToggleAt = now;

    if (section === 'myInvestments') {
      this.myInvestmentsCollapsed = !this.myInvestmentsCollapsed;
    } else if (section === 'digitalWallet') {
      this.digitalWalletCollapsed = !this.digitalWalletCollapsed;
    } else if (section === 'help') {
      this.helpCollapsed = !this.helpCollapsed;
    }
    this.crf.detectChanges();
  }

  logout() {
    Swal.fire({
      icon: 'info',
      title: '¿Quieres salir de la aplicación?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Cancelar',
      cancelButtonText: `Ok`,
    }).then(async (result: any) => {
      if (!result.isConfirmed) {
        await this.authSrv.logout();
        this.router.navigateByUrl('/login');
      }
    });
  }

  ngOnInit(): void {
    // Lógica simple para detectar cuando el menú está abierto/cerrado
    const offcanvasElement = document.getElementById('offcanvasNavbar');
    if (offcanvasElement) {
      offcanvasElement.addEventListener('shown.bs.offcanvas', () => {
        this.menuOpened = true;
        this.crf.detectChanges();
      });

      offcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
        this.menuOpened = false;
        this.crf.detectChanges();
      });
    }

    this.authSrv.userAuth.subscribe((res: any) => {
      this.userAuth = res;
      this.crf.detectChanges();
    });

    this.authSrv.loggedIn.subscribe((res: any) => {
      this.loggedIn = res;
      this.crf.detectChanges();
    });

    this.authSrv.admin.subscribe((res: any) => {
      this.adminFlag = res;
      this.crf.detectChanges();
    });

    this.kycSrv.kycSuccess.subscribe((res: any) => {
      this.kycFlag = res;
      this.canCheckBalance = res.success;
      this.crf.detectChanges();
    });

    this.digitalWalletSrv.currentBalance.subscribe((res: any) => {
      if (res) {
        this.balance = res.balance;
        this.balanceError = res.balanceError;
        this.isLoadingBalance = res.isLoadingBalance;
        this.crf.detectChanges();
      }
    });

    this.authSrv.userAuth.subscribe((res: any) => {
      this.userAuth = res;
      this.afs.collection('users').doc(res?.uid).valueChanges().subscribe((user: any) => {
          // Firebase puede emitir fuera de la zona de Angular → forzamos CD.
          this.ngZone.run(() => {
            this.hideBlockchain = user?.hideBlockchain ?? true;
            this.crf.detectChanges();
          });
          })
      this.crf.detectChanges();
    });
  }

  openModalKyc() {
    this.modalKycSrv.openModalKyc();
  }

 async checkFunds() {
    if(!this.firstTime){
      this.digitalWalletSrv.setBalance({
        isLoadingBalance: true,
        balance: 0
      });
      this.firstTime = true;
      await (new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 5000)
      }))
    }
    if(this.canCheckBalance){
      console.log('Checking funds...');
      this.counter++
      console.log('lock status:', this.lock);
      this.digitalWalletSrv.checkFunds();
      console.log('Intento de checkFunds:', this.counter);
      console.log('funds check:');
      if(this.counter > 2){
        console.log('Bloqueando el botón de checkFunds');        
        this.lockButton();
      }
    }
    else
      this.digitalWalletSrv.setBalance({
        isLoadingBalance: false,
        balanceError: true,
        canCheckBalance:false,
        balance: 0
      });
  }

  lockButton() {
    this.lock = true;
    setTimeout(() => {
      this.counter = 0;
      this.lock = false;
    }, 10000);
  }

  selectedMenu(collapsed: string){
    switch (collapsed) {
      case 'digitalWalletCollapsed':
        this.digitalWalletCollapsed = !this.digitalWalletCollapsed;
        this.eurosCollapsed = false;
        this.helpCollapsed = false;
        this.profileCollapsed = false;
        this.myInvestmentsCollapsed = false;
        break;
      case 'eurosCollapsed':
        this.eurosCollapsed = !this.eurosCollapsed;
        // this.digitalWalletCollapsed = false;
        this.helpCollapsed = false;
        this.profileCollapsed = false;
        this.myInvestmentsCollapsed = false;
        break;
      case 'helpCollapsed':
        this.helpCollapsed = !this.helpCollapsed;
        this.digitalWalletCollapsed = false;
        this.eurosCollapsed = false;
        this.profileCollapsed = false;
        this.myInvestmentsCollapsed = false;
        break;
      case 'profileCollapsed':
        this.profileCollapsed = !this.profileCollapsed;
        this.digitalWalletCollapsed = false;
        this.eurosCollapsed = false;
        this.helpCollapsed = false;
        this.myInvestmentsCollapsed = false;
        break;
      case 'myInvestmentsCollapsed':
        this.myInvestmentsCollapsed = !this.myInvestmentsCollapsed;
        this.digitalWalletCollapsed = false;
        this.eurosCollapsed = false;
        this.helpCollapsed = false;
        this.profileCollapsed = false;
        break;
        case 'referralsCollapsed':  
        this.referralsCollapsed = !this.referralsCollapsed;
        this.digitalWalletCollapsed = false;
        this.eurosCollapsed = false;
        this.helpCollapsed = false;
        this.profileCollapsed = false;
        this.myInvestmentsCollapsed = false;
        break;
      default: 
        break;
    }
  }
}
